import MixedBannerDisplay from "./MixedBannerDisplay";

export default MixedBannerDisplay;